<ng-container *ngIf="visible$ | async">
  <ul>
    <li *ngFor="let item of parts$ | async">
      {{ item.quantity }} x <ish-product-name ishProductContext [sku]="item.sku" [link]="false"></ish-product-name>
    </li>
  </ul>
</ng-container>
